import { useStyles } from "./styles";
import { brazilianStates, emailRegex } from "../../utils/constants";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import theme from "../../theme";
import { TextField, Typography, Select, MenuItem, FormControl } from "@material-ui/core";
import { useEffect, useState } from "react";
import { CpfMask, PhoneMask, dateMask, formatCEP } from "../../utils/masks";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box } from "@mui/material";
interface IDependentOne {
  body: any;
  setBody: any;
  setValidationFormOne?: (value: boolean) => void;
  searchPostalCode: () => Promise<void>;
  index: number;
  onValidationChange: (index: number, isValid: boolean) => void;
}

export function AccordionDependent({
  body,
  setBody,
  setValidationFormOne,
  searchPostalCode,
  index,
  onValidationChange,
}: IDependentOne) {
  const classes = useStyles();
  const [isCompleted, setIsCompleted] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<string>("");

  

  const hasEmptyFields = (data: any) => {
    for (const key in data) {
      if (typeof data[key] === "string" && data[key].trim() === "") {
        return true;
      }
    }
    return false;
  };

  const isDataValid = !hasEmptyFields(body);
  const isAddressValid = !hasEmptyFields(body?.address);

  useEffect(() => {
    if (isDataValid && isAddressValid) {
      setIsCompleted(true);
      onValidationChange(index, true);
    } else {
      setIsCompleted(false);
      onValidationChange(index, false);
    }
  }, [isDataValid, isAddressValid, index, onValidationChange]);

  useEffect(() => {
    searchPostalCode();
  }, [body?.address?.zip_code]);

  return (
    <Accordion
      sx={{
        backgroundColor: theme.palette.primary.main,
      }}
      className={classes.accordion}
    >
      <AccordionSummary
        sx={{
          "& .MuiAccordionSummary-expandIconWrapper": {
            transition: "transform 0.3s ease",
            transform: isCompleted ? "rotate(0deg)" : "rotate(180deg)",
          },
        }}
        expandIcon={
          isCompleted ? (
            <CheckCircleIcon sx={{ color: "white", borderRadius: "10px" }} />
          ) : (
            <CancelIcon sx={{ color: "red", borderRadius: "10px" }} />
          )
        }
      >
        <Typography className={classes.accordionTitle}>
          Dependente adicional - n.° {index + 1}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        style={{
          backgroundColor: "white",
          border: `1px solid ${theme.palette.primary.main}`,
        }}
      >
        <form>
          <label className={classes.label}>Nome completo</label>
          <TextField
            name="name"
            variant="outlined"
            size="small"
            fullWidth
            style={{ marginTop: "5px", marginBottom: "20px" }}
            value={body?.name}
            onChange={(e) => setBody({ ...body, name: e.target.value })}
          />
          <Box className={classes.divRow}>
            <Box className={classes.labelAndInput}>
              <label className={classes.label}>Data nascimento</label>
              <TextField
                name="birthday"
                variant="outlined"
                size="small"
                fullWidth
                style={{
                  marginTop: "5px",
                  marginBottom: "20px",
                }}
                value={dateMask(body?.birthday) ?? body?.birthday}
                onChange={(e) => setBody({ ...body, birthday: e.target.value })}
                inputProps={{ maxLength: 10 }}
              />
            </Box>
            <Box className={classes.labelAndInput}>
              <label className={classes.label}>CPF</label>
              <TextField
                name="cpf"
                variant="outlined"
                size="small"
                fullWidth
                style={{ marginTop: "5px", marginBottom: "20px" }}
                value={CpfMask(body?.cpf) ?? body?.cpf}
                onChange={(e) => setBody({ ...body, cpf: e.target.value })}
                inputProps={{ maxLength: 14 }}
              />
            </Box>
            <Box className={classes.labelAndInput}>
              <label className={classes.label}>Telefone de contato</label>
              <TextField
                name="phone"
                variant="outlined"
                size="small"
                fullWidth
                style={{ marginTop: "5px", marginBottom: "20px" }}
                value={PhoneMask(body?.phone) ?? body?.phone}
                onChange={(e) => setBody({ ...body, phone: e.target.value })}
              />
            </Box>
          </Box>
          <label className={classes.label}>E-mail</label>
          <TextField
            name="email"
            variant="outlined"
            size="small"
            fullWidth
            style={{ marginTop: "5px", marginBottom: "20px" }}
            value={body?.email}
            onChange={(e) => {
              const value = e.target.value;
              setBody({ ...body, email: value });
              if (value && !emailRegex.test(value)) {
                setEmailError("Email inválido");
              } else {
                setEmailError("");
              }
            }}
            error={!!emailError}
            helperText={emailError}
          />
          <label className={classes.label}>CEP</label>
                     <TextField
             name="cep"
             variant="outlined"
             size="small"
             fullWidth
             style={{ marginTop: "5px", marginBottom: "20px" }}
             value={body?.address?.zip_code}
             onChange={(e) => {
               const value = e.target.value;
               const formattedValue = formatCEP(value);
               setBody({
                 ...body,
                 address: { ...body.address, zip_code: formattedValue },
               });
             }}
             inputProps={{ maxLength: 9 }}
           />
          <label className={classes.label}>Endereço</label>
          <TextField
            name="address"
            variant="outlined"
            size="small"
            fullWidth
            style={{ marginTop: "5px", marginBottom: "20px" }}
            value={body?.address?.street}
            onChange={(e) =>
              setBody({
                ...body,
                address: { ...body.address, street: e.target.value },
              })
            }
          />
          <Box className={classes.divRow}>
            <Box className={classes.labelAndInput}>
              <label className={classes.label}>Bairro</label>
              <TextField
                name="neighborhood"
                variant="outlined"
                size="small"
                fullWidth
                style={{ marginTop: "5px", marginBottom: "20px" }}
                value={body?.address?.neighborhood}
                onChange={(e) =>
                  setBody({
                    ...body,
                    address: { ...body.address, neighborhood: e.target.value },
                  })
                }
              />
            </Box>
            <Box className={classes.labelAndInput}>
              <label className={classes.label}>Número</label>
              <TextField
                name="number"
                variant="outlined"
                size="small"
                fullWidth
                style={{ marginTop: "5px", marginBottom: "20px" }}
                value={body?.address?.number}
                onChange={(e) =>
                  setBody({
                    ...body,
                    address: { ...body.address, number: e.target.value },
                  })
                }
              />
            </Box>
            <Box className={classes.labelAndInput}>
              <label className={classes.label}>Complemento</label>
              <TextField
                name="complement"
                variant="outlined"
                size="small"
                fullWidth
                style={{ marginTop: "5px", marginBottom: "20px" }}
                value={body?.address?.complement}
                onChange={(e) =>
                  setBody({
                    ...body,
                    address: { ...body.address, complement: e.target.value },
                  })
                }
              />
            </Box>
          </Box>
          <Box className={classes.divRow}>
            <Box className={classes.labelAndInput}>
              <label className={classes.label}>Cidade</label>
              <TextField
                name="city"
                variant="outlined"
                size="small"
                fullWidth
                style={{ marginTop: "5px", marginBottom: "20px" }}
                value={body?.address?.city}
                onChange={(e) =>
                  setBody({
                    ...body,
                    address: { ...body.address, city: e.target.value },
                  })
                }
              />
            </Box>
            <Box className={classes.labelAndInput}>
              <label className={classes.label}>Estado</label>
              <FormControl fullWidth size="small" style={{ marginTop: "5px", marginBottom: "20px" }}>
                <Select
                  value={body?.address?.state || ""}
                  onChange={(e) =>
                    setBody({
                      ...body,
                      address: { ...body.address, state: e.target.value },
                    })
                  }
                  displayEmpty
                  variant="outlined"
                >
                  <MenuItem value="" disabled>
                    Selecione um estado
                  </MenuItem>
                  {brazilianStates.map((state) => (
                    <MenuItem key={state.code} value={state.code}>
                      {state.code} - {state.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
        </form>
      </AccordionDetails>
    </Accordion>
  );
}
